module.exports = __webpack_public_path__ + "img/facilitator.5a6ffc9.jpg";